import Vue from "vue";

// axios
import axios from "axios";
const endpoint = process.env.VUE_APP_API_URL_UGEMS_ACADEMY
  ? process.env.VUE_APP_API_URL_UGEMS_ACADEMY
  : `http://localhost:3107`;

const axiosInsAcademy = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: '/api',
  // baseURL: 'https://5f45-2001-448a-2020-3be3-81d8-774f-f420-6a31.ap.ngrok.io/hms/api',
  baseURL: endpoint,
  timeout: Number(process.env.VUE_APP_API_TIMEOUT_MS || 30000),
  headers: {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": true,

  },
});

axiosInsAcademy.interceptors.request.use(
  (config) => {
    const token_auth = localStorage.getItem("ugems-accessToken");
    if (token_auth) {
      config.headers.Authorization = `Bearer ${token_auth}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInsAcademy.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // if(!(router.history.current.path).includes("login") && error.response.status == 401){
    //   console.log('path is not login & status code 401');

    //   // Remove userData from localStorage
    //   localStorage.removeItem('userData')

    //   // Redirect to login page
    //   router.push({ name: 'auth-login' })
    // }
    // console.log(`error : ${error.response.status}`);
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosInsAcademy;

export default axiosInsAcademy;
